// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"SociometryDelete_actionButton__39ize","icon":"SociometryDelete_icon__2aKJI"};